<div
    class="wrapper"
    [style.background-image]="'url(' + task.backgroundImage + ')'">
    <nb-card class="task-area">
        <nb-card-body></nb-card-body>
        <nb-card-footer class="border-top-0 pl-3">
            <p class="task-title mb-2 text-left">{{ task.title }}</p>
            <button
                nbButton
                size="tiny"
                class="task-button text-left text-uppercase"
                (click)="performAction()">
                {{ task.buttonText }}
            </button>
        </nb-card-footer>
    </nb-card>
</div>
